import Vue from 'vue'
import ContactForm from './ContactForm'

Vue.component('contact-form', ContactForm)

// eslint-disable-next-line no-new
new Vue({
  el: '#laravel-contact'
})
